import React from 'react';
import { connect } from 'react-redux';
import { setModal } from '../../redux/actions/stock_transfer/stock_transfer.actions';
import ReactTooltip from 'react-tooltip';
import StockTransferTable from './StockTransfer.table';
import { Show } from 'react-redux-permission';

function StockTransfer({ setModal }) {
    return (
        <div className="app-content content">
            <ReactTooltip effect="solid" event="click" />
            <div className="content-wrapper max-1920 mx-auto">
                <div className="content-wrapper-before"></div>
                <div className="content-header row">
                    <div className="content-header-left col-md-12 col-12 mb-2 breadcrumb-new fix-header">
                        <h3 className="content-header-title mb-0 d-inline-block">
                            Inventory
                        </h3>
                        <div className="breadcrumbs-top d-inline-block">
                            <div className="breadcrumb-wrapper mr-1">
                                <ol className="breadcrumb f-regular">
                                    <li className="breadcrumb-item">
                                        <a
                                            href="/inventory/stock-transfer"
                                            className="text-white"
                                        >
                                            Stock Transfer
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content-body margin-top-5">
                    <section id="basic-examples">
                        <div className="row">
                            <div className="col-sm-12">
                                <Show when="inv.inventory.stock-transfer.view">
                                    <div className="content-body margin-top-5">
                                        <section id="basic-examples">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="card">
                                                        <div className="card-header">
                                                            <h4 className="card-title">
                                                                List of Transfers{' '}
                                                                <a
                                                                    href="#"
                                                                    className="tool-tip"
                                                                    data-tip="this is a tool tip"
                                                                >
                                                                    <i className="la la-question-circle"></i>
                                                                </a>
                                                                <Show when="inv.inventory.stock-transfer.create">
                                                                    <button
                                                                        className="btn btn-primary pull-right btn-sm m-1"
                                                                        onClick={() =>
                                                                            setModal(
                                                                                'multi_stock_transfer_modal',
                                                                                true
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="ft ft-plus"></i>{' '}
                                                                        Multi Transfer
                                                                    </button>
                                                                </Show>
                                                                <Show when="inv.inventory.stock-transfer.create">
                                                                    <button
                                                                        className="btn btn-primary pull-right btn-sm m-1"
                                                                        onClick={() =>
                                                                            setModal(
                                                                                'stock_transfer_modal',
                                                                                true
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="ft ft-plus"></i>{' '}
                                                                        Quick Transfer
                                                                    </button>
                                                                </Show>
                                                            </h4>
                                                        </div>
                                                        <div className="card-content collapse show">
                                                            <div className="card-body">
                                                                <Show when="inv.inventory.stock-transfer.view">
                                                                    <section className="row f-regular">
                                                                        <div className="col-sm-12">
                                                                            <StockTransferTable />
                                                                        </div>
                                                                    </section>
                                                                </Show>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </Show>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    stock_transfer: state.stock_transfer,
});

export default connect(mapStateToProps, { setModal })(StockTransfer);
